import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Button } from "@wfp/ui";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import DeleteModal, { DeleteModalSection } from "components/DeleteModal";
import { isReportOpenByDate } from "helpers/report";
import { Store } from "data-handler/ducks/stores";

type DeleteModalButtonProps = {
  currentStoreData: Store;
  section?: DeleteModalSection;
  title?: React.ReactNode;
  disabled?: boolean;
  customRedirectPath?: string;
  skipReportOpenCheck?: boolean;
};

const DeleteModalButton: React.ComponentType<DeleteModalButtonProps> = ({
  currentStoreData,
  section,
  title,
  disabled,
  customRedirectPath,
  skipReportOpenCheck = false,
}) => {
  const [deleteModalState, setDeleteModalState] = useState(false);
  const getDate =
    (currentStoreData as any)?.occurred_on ||
    (currentStoreData as any)?.occurred_at;

  const isReportOpen = useSelector(isReportOpenByDate(getDate));
  const reportGateOpen = skipReportOpenCheck || isReportOpen;

  return (
    <>
      <Button
        kind="danger"
        icon={<FontAwesomeIcon icon={faChevronRight} />}
        onClick={() => setDeleteModalState(true)}
        disabled={disabled || !reportGateOpen}
      >
        {title ? (
          title
        ) : (
          <FormattedMessage
            id="IncidentShow.deleteIncident"
            defaultMessage="Delete"
          />
        )}
      </Button>
      <DeleteModal
        state={deleteModalState}
        setState={setDeleteModalState}
        currentStoreData={currentStoreData}
        section={section}
        customRedirectPath={customRedirectPath as any}
      />
    </>
  );
};

export default DeleteModalButton;
